import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Conversation } from './conversation.model';

export const loadConversations = createAction(
  '[Conversation/API] Load Conversations',
  props<{ conversations: Conversation[] }>()
);

export const addConversation = createAction(
  '[Conversation/API] Add Conversation',
  props<{ conversation: Conversation }>()
);

export const upsertConversation = createAction(
  '[Conversation/API] Upsert Conversation',
  props<{ conversation: Conversation }>()
);

export const addConversations = createAction(
  '[Conversation/API] Add Conversations',
  props<{ conversations: Conversation[] }>()
);

export const upsertConversations = createAction(
  '[Conversation/API] Upsert Conversations',
  props<{ conversations: Conversation[] }>()
);

export const updateConversation = createAction(
  '[Conversation/API] Update Conversation',
  props<{ conversation: Update<Conversation> }>()
);

export const updateConversations = createAction(
  '[Conversation/API] Update Conversations',
  props<{ conversations: Update<Conversation>[] }>()
);

export const deleteConversation = createAction(
  '[Conversation/API] Delete Conversation',
  props<{ id: string }>()
);

export const deleteConversations = createAction(
  '[Conversation/API] Delete Conversations',
  props<{ ids: string[] }>()
);
export const getConversations = createAction(
  '[Conversation/API] Get Conversations',
  props<{ orderId: number }>(),
);
export const getConversationsSimple = createAction(
  '[Conversation/API] Get Conversations'
);
export const clearConversations = createAction(
  '[Conversation/API] Clear Conversations'
);
export const loadConversationsSuccess = createAction(
  '[Conversation/API] Load Conversations Success',
  props<{ conversation: Conversation }>()
);
